import _ from 'lodash';

const encodeAddressAutocompleteObj = (autocomplete) =>
  autocomplete.hotelId
    ? _.pick(autocomplete, ['hotelId', 'label', 'lat', 'lon'])
    : _.pick(autocomplete, ['value', 'label']);

export default encodeAddressAutocompleteObj;
